
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/yhteystiedot",
      function () {
        return require("private-next-pages/yhteystiedot.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/yhteystiedot"])
      });
    }
  